import { render, staticRenderFns } from "./Landing4WeHelpYou.vue?vue&type=template&id=b804cbce&scoped=true&"
import script from "./Landing4WeHelpYou.vue?vue&type=script&lang=js&"
export * from "./Landing4WeHelpYou.vue?vue&type=script&lang=js&"
import style0 from "./Landing4WeHelpYou.vue?vue&type=style&index=0&id=b804cbce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b804cbce",
  null
  
)

export default component.exports